export default __webpack_public_path__ + "static/media/SfDistantGalaxy-0l3d.ee1b4a35.ttf";